import { Icon, Typography } from '@/components';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';

export function OpportunityDealManager() {
  const { t } = useTranslation(['opportunities']);
  return (
    <Card >
      <CardHeader>
        <CardTitle>
          <Typography as="h3" weight="semibold" size="title" className="uppercase">
            {t('Deal Manager')}
          </Typography>
        </CardTitle>
      </CardHeader>

      <CardContent className="space-y-3">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 overflow-hidden rounded-full">
            <img
              src="/images/deal-manager-nteaser.png"
              width={64}
              height={64}
              className="h-full w-full object-cover"
              alt="Deal Manager nTeaser"
            />
          </div>
          <div>
            <h3 className="font-medium">
              Rodrigo R. Ponga <span className="text-sm font-normal text-gray-500">(M&A Manager)</span>
            </h3>
            <div className="mt-1 flex items-center gap-2 text-sm text-green-700">
              <Icon name="mail" className="h-5 w-5" />
              <a href="mailto:rodrigo@nteaser.com">rodrigo@nteaser.com</a>
            </div>
            <div className="mt-1 flex items-center gap-2 text-sm text-green-700">
              <Icon name="phone" className="h-4 w-4" />
              <a href="tel:+34 674 618 782">+34 674 618 782</a>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
